let validatedEmail;

function getParameterByName (name) {
    const url = window.location.href;

    name = name.replace(/[\[\]]/g, '\\$&');

    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(url);

    if (! results) {
        return null;
    }

    if (! results[2]) {
        return '';
    }

    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

( function (a) {

    const emailRegex = new RegExp(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

    if (a('.immediate-registration').length) {
        const $immediateRegistrationForm = a('form.immediate-registration');

        const $emailField = $immediateRegistrationForm.find('input[name=email]');
        const $submitButton = $immediateRegistrationForm.find('input[type=submit]');
        const $helpWrapper = $immediateRegistrationForm.find('.help');

        $emailField.on('focus', () => $helpWrapper.hide());

        $immediateRegistrationForm.on('submit', () => {
            const emailValue = $emailField.val();

            if (! emailValue || ! emailValue.length || ! emailRegex.test(emailValue)) {
                $helpWrapper.show();

                return false;
            }

            $submitButton.addClass('is-loading');
        });
    }

    if (a('#session-form').length) {
        let listenToAutofill = true;

        const $sessionForm = a('#session-form');
        const $resendFormationForm = $sessionForm.find('.resend-notification-action');

        const $passwordField = $sessionForm.find('.password-field');
        const $submitField = $sessionForm.find('.submit-field');
        const $emailInput = $sessionForm.find('input[name=email]');
        const $submitButton = $sessionForm.find('button[type=submit]');
        const $helpForEmail = $sessionForm.find('.help.for-email');

        const verifyLogin = function () {
            const emailValue = $emailInput.val();

            $sessionForm.find('.help').hide();

            if (! emailValue || ! emailValue.length || ! emailRegex.test(emailValue)) {
                $passwordField.hide();
                $submitField.hide();
                $submitButton.attr('disabled', 'disabled');

                return $helpForEmail.show();
            }

            a.ajax('/login/verify', {
                method: 'POST',
                dataType: 'json',
                data: {
                    email: emailValue
                },

                success (response) {
                    if (response) {
                        if (! response.is_valid) {
                            $helpForEmail.show();
                            $resendFormationForm.hide();
                        }

                        if (! response.is_valid || ! response.is_verified) {
                            $passwordField.hide();
                            $submitField.hide();
                            $submitButton.attr('disabled', 'disabled');
                        }

                        if (response.email === emailValue && response.is_valid && !response.is_verified) {
                            validatedEmail = emailValue;
                            $resendFormationForm.show();
                        }

                        if (response.email === emailValue && response.is_valid && response.is_verified) {
                            $helpForEmail.hide();
                            $resendFormationForm.hide();
                            $passwordField.show();
                            $submitField.show();

                            $submitButton.removeAttr('disabled');
                        }
                    }
                }
            });
        };

        $emailInput.on('change', _.debounce(verifyLogin, 250));

        // Handle auto fill event for Firefox
        setTimeout( function () {
            verifyLogin();
        }, 0);
    }

    if (a('body.signup-confirmation').length && getParameterByName('email')) {
        const $resendConfirmationNotification = a('.resend-notification-action');

        if ($resendConfirmationNotification.length) {
            setTimeout( function () {
                $resendConfirmationNotification.show();
            }, 15000);
        }
    }

    const $resendNotificationButton = a('.resend-notification');
    if ($resendNotificationButton.length) {
        $resendNotificationButton.on('click', () => {
            let emailValue;

            if (validatedEmail) {
                emailValue = validatedEmail;
            }

            else if (a('[name=email]').length) {
                emailValue = a('[name=email]').val();
            }

            else {
                emailValue = getParameterByName('email');
            }

            $resendNotificationButton.addClass('is-loading').attr('disabled');

            a.ajax('/confirmation/resend/' + emailValue, {
                method: 'POST',

                dataType: 'json',

                success () {
                    $resendNotificationButton.removeClass('is-loading').addClass('is-done');
                }
            });
        });
    }

}(jQuery));
